import {combineEpics} from 'redux-observable'
import {epic as appEpic} from './app/epic'
import {epic as flashEpic} from './components/flash-message'
import {epic as formEpic} from './components/form'
import {epic as menuEpic} from './components/menu'
import {epic as userMenuEpic} from './components/menu/user-menu'
import {epic as configEpic} from './config/epic'
import {epic as adminReportsEpic} from './pages/admin-reports'
import {epic as authEpic} from './pages/auth/epic'
import {epic as excludedEpic} from './pages/blacklists'
import {epic as communityEpic} from './pages/communities'
import {epic as communityConfigEpic} from './pages/community-config'
import {epic as contentCalendarEpic} from './pages/content-calendar/epic'
import {epic as createCommunityEpic} from './pages/create-community'
import {epic as domainAuthEpic} from './pages/domain-authentication'
import {epic as domainDeliverabilityEpic } from './pages/domain-deliverability'
import {epic as dropsEpic} from './pages/drops'
import {epic as engagementSummaryEpic} from './pages/engagement-summary'
import {epic as feedbackEpic} from './pages/feedback'
import {epic as filterGroupEpic} from './pages/filter-group'
import {epic as filterGroupsEpic} from './pages/filter-groups'
import {epic as forgotPasswordEpic} from './pages/forgot-password'
import {epic as homeEpic} from './pages/home/epic'
import {epic as importsEpic } from './pages/imports'
import {epic as importErrorsEpic } from './pages/imports/errors'
import {epic as integrationMappingsEpic } from './pages/integration-mappings'
import {epic as integrationReportsEpic } from './pages/integration-reports'
import {epic as integrationsEpic } from './pages/integrations'
import {epic as ipPoolsEpic} from './pages/ip-pools'
import {epic as leadPostsEpic} from './pages/lead-posts'
import {epic as addEditLeadTextEpic} from './pages/lead-text/add-edit-modal'
import {epic as leadTextEpic} from './pages/lead-text/epics'
import {epic as loginEpic} from './pages/login'
import {epic as logoutEpic} from './pages/logout'
import {epic as memberEpic} from './pages/member-details'
import {epic as membersEpic} from './pages/members'
import {epic as newsbriefEpic} from './pages/newsbrief'
import {epic as newsbriefCountsEpic} from './pages/newsbrief-counts'
import {epic as oauthLoginEpic} from './pages/oauth-login'
import {epic as postEpic} from './pages/posts'
import {epic as promotionsEpic} from './pages/promotions'
import {epic as referenceDataEpic} from './pages/reference/epic'
import {epic as referralCampaigns} from './pages/referral-campaigns/epic'
import {epic as reportsEpic} from './pages/reports'
import {epic as resetPasswordEpic} from './pages/reset-password'
import {epic as schedulesEpic} from './pages/schedules'
import {epic as sourceConfigEpic} from './pages/source-config'
import {epic as sourcesEpic} from './pages/sources'
import {epic as trainingEpic} from './pages/training'
import {epic as upcomingSchedulesEpic} from './pages/upcoming-schedules'
import {epic as userSettingsEpic} from './pages/user-settings'
import {epic as usersEpic} from './pages/users'
import {epic as requestEpic} from './request'
import {epic as routerEpic} from './router'

export const rootEpic = combineEpics(
  addEditLeadTextEpic,
  adminReportsEpic,
  appEpic,
  authEpic,
  communityConfigEpic,
  communityEpic,
  configEpic,
  contentCalendarEpic,
  createCommunityEpic,
  domainAuthEpic,
  domainDeliverabilityEpic,
  dropsEpic,
  engagementSummaryEpic,
  excludedEpic,
  feedbackEpic,
  filterGroupEpic,
  filterGroupsEpic,
  flashEpic,
  forgotPasswordEpic,
  formEpic,
  homeEpic,
  importErrorsEpic,
  importsEpic,
  integrationMappingsEpic,
  integrationReportsEpic,
  integrationsEpic,
  ipPoolsEpic,
  leadPostsEpic,
  leadTextEpic,
  loginEpic,
  logoutEpic,
  memberEpic,
  membersEpic,
  menuEpic,
  newsbriefCountsEpic,
  newsbriefEpic,
  oauthLoginEpic,
  postEpic,
  promotionsEpic,
  referenceDataEpic,
  referralCampaigns,
  reportsEpic,
  requestEpic,
  resetPasswordEpic,
  routerEpic,
  schedulesEpic,
  sourceConfigEpic,
  sourcesEpic,
  trainingEpic,
  upcomingSchedulesEpic,
  userMenuEpic,
  userSettingsEpic,
  usersEpic,
)



// WEBPACK FOOTER //
// ./src/rootEpic.ts